export enum IMAGE_LOADING {
    LAZY = 'lazy',
    EAGER = 'eager',
}

export enum IMAGE_FETCH_PRIORITY {
    AUTO = 'auto',
    HIGH = 'high',
    LOW = 'low',
}

export interface LazyImageBinding {
    src: string;
    tag?: string;
    loading?: IMAGE_LOADING;
    fetchPriority?: IMAGE_FETCH_PRIORITY;
    cdnPrefixes?: string[];
}

export interface LazyImageDirectiveBinding extends Omit<
    LazyImageBinding,
    'src'
> {
    src?: string;
    format?: string | false;
    quality?: string | number;
    version?: string | number | boolean;
    width?: string | number;
}
